<template>
    <div class='option' @click="click" :style="style">
        <div class="gradient" />
        <div class='d-flex content'>
            <span>{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'picker-option',
    props: ['text', 'image'],

    data(){
        let colors = ["#1abc9c", "#2980b9", "#2c3e50", "#c0392b", "#8e44ad", "#f39c12"]
        let color = colors[Math.floor(Math.random()*colors.length)];
        return {
            color: color
        }
    },

    computed: {

        style(){
            return {
                width: this.width() + "px",
                backgroundColor: this.color
            }
        }
    },

    methods: {
        click() {
            this.$emit('option-picked', this.text);
        },

        width(){
            if(window.innerWidth < 760)
                return window.innerWidth / 4;
            return window.innerWidth / 10
        }
    }
}
</script>

<style lang="scss" scoped>
    .option {   
        float: left;
        display: inline-block;
        position: relative;
        background-size: cover;
        cursor: pointer;
        width: 200px;

        .gradient {z-index: 1; position: absolute; height: 100%; width: 100%; opacity: 0.4; transition: opacity 0.3s}
        DIV.content {position: relative; z-index: 2; padding: 10px; text-align: center; align-items: center; justify-content: center; width: 100%; height: 70px; color: white; font-weight: 700; font-size: 15px}
    }

    .option:hover .gradient {opacity: 0.1;}

    @media (max-width: 767.98px) { 
        .option DIV.content {height: 60px; font-size: 12px;}
    }
</style>